package ru.villawonka.app.resources.strings

class RuStringResources : StringResources {
    override fun helloMessage(deeplink: String): String =
        "Добрый день! Я увидел ваше объявление в боте VillaWonka ($deeplink). Подскажите, оно ещё актуально?"

    override val stubHttpError: String
        get() = "Не удалось загрузить данные,\n" +
                "попробуйте ещё раз или зайдите позже."
    override val stubNoConnection: String
        get() = "Нет подключения к интернету.\n" +
                "Проверьте соединение и попробуйте снова."
    override val stubNotFound: String
        get() = "Мы не смогли найти то, что вы искали. Возможно, данные были удалены или изменились."
    override val stubRetryButton: String
        get() = "Обновить"
    override val conversationDetailsTitle: String
        get() = "Конвертация валюты"
    override fun conversationDetailsDescription(
        originalCurrencyCode: String,
        displayCurrencyCode: String
    ): String = "Цена конвертирована из местной валюты ($originalCurrencyCode) в выбранную вами валюту ($displayCurrencyCode) по текущему курсу."
    override val conversationDetailsOriginalCost: String
        get() = "• Оригинальная цена:"
    override val conversationDetailsExchangeRate: String
        get() = "• Курс обмена:"
    override val conversationDetailsExchangeRateDate: String
        get() = "• Дата актуальности курса:"
    override val conversationDetailsSummary: String
        get() = "• Итог:"
    override val goToSource: String
        get() = "Перейти к источнику"
    override val badgeNew: String
        get() = "Новое"
    override val postCardRentCost: String
        get() = "Стоимость"
    override val postCardRentDeposit: String
        get() = "Залог"
    override val postCardRentFrom: String
        get() = "Сдаётся с"
    override val postCardRentTo: String
        get() = "Сдаётся до"
    override val postCardDescriptionTab: String
        get() = "Описание"
    override val postCardRentTab: String
        get() = "Аренда"
    override val postCardAmenitiesTab: String
        get() = "Удобства"
    override val postCardMore: String
        get() = "Подробнее"
    override val postCardHide: String
        get() = "Скрыть"
    override val postCardSendMessage: String
        get() = "Отправить сообщение"
    override val additionIncluded: String
        get() = "Включено"
    override val additionNearby: String
        get() = "Рядом"
    override val additionAvailable: String
        get() = "Есть"
    override val accommodationAdditionPool: String
        get() = "Бассейн"
    override val accommodationAdditionUtilityBillsIncluded: String
        get() = "Ком. платежи"
    override val accommodationAdditionNearGym: String
        get() = "Тренажерный зал"
    override val accommodationAdditionNearCafe: String
        get() = "Кафе"
    override val accommodationAdditionParking: String
        get() = "Парковка"
    override val accommodationAdditionWiFi: String
        get() = "Wi-Fi"
    override val accommodationAdditionCleaning: String
        get() = "Уборка"
    override val accommodationAdditionAirCondition: String
        get() = "Кондиционер"
    override val accommodationAdditionNearBeach: String
        get() = "Пляж"
    override val accommodationAdditionClosedLivingRoom: String
        get() = "Закрытая гостинная"
    override val accommodationAdditionTerrace: String
        get() = "Терраса"
    override val accommodationAdditionJacuzzi: String
        get() = "Джакузи"
    override val accommodationAdditionWashingMachine: String
        get() = "Стиральная машина"
    override val accommodationAdditionTV: String
        get() = "Телевизор"
    override val accommodationAdditionSafe: String
        get() = "Сейф"
    override val accommodationAdditionClosedKitchen: String
        get() = "Закрытая кухня"
    override val accommodationAdditionVideoSurveillance: String
        get() = "Видеонаблюдение"
    override val accommodationAdditionBarbecueArea: String
        get() = "Зона барбекю"
    override val accommodationAdditionDrinkWaterIncluded: String
        get() = "Питьевая вода"
    override val accommodationAdditionHasDiscount: String
        get() = "Скидка"
    override val rentType: String
        get() = "Вид аренды"
    override val rentTypeMonthly: String
        get() = "Помесячно"
    override val rentTypePeriod: String
        get() = "Период"
    override val rentTypeAnnually: String
        get() = "Годично"
    override val rentTypeDaily: String
        get() = "Посуточно"
    override val accommodationType: String
        get() = "Вид жилья"

    override val searchResultTitle: String
        get() = "Результаты поиска"
    override val countryIndonesia: String
        get() = "Индонезия"
    override val countryThailand: String
        get() = "Таиланд"
    override val countryVietnam: String
        get() = "Вьетнам"
    override val currencyRub: String
        get() = "Российский рубль"
    override val currencyUsd: String
        get() = "Доллар США"
    override val currencyIdr: String
        get() = "Индонезийская рупия"
    override val currencyThb: String
        get() = "Тайский бат"
    override val currencyVnd: String
        get() = "Вьетнамский донг"
    override val currencyCny: String
        get() = "Китайский юань"
    override val languageRussian: String
        get() = "Русский"
    override val languageEnglish: String
        get() = "Английский"
    override val languageRussianNative: String
        get() = "Русский"
    override val languageEnglishNative: String
        get() = "English"
    override val bottomNavSearch: String
        get() = "Поиск"
    override val bottomNavFavorites: String
        get() = "Избранное"
    override val tabBarItemProperty: String
        get() = "Недвижимость"
    override val tabBarItemTransport: String
        get() = "Транспорт"
    override val tabBarItemMoneyExchange: String
        get() = "Обмен валюты"
    override val tabBarItemVisaAgency: String
        get() = "Виза"
    override val tabBarSoonBadge: String
        get() = "Скоро"
    override val topBarItemFilter: String
        get() = "Фильтр"
    override val topBarItemSort: String
        get() = "Сортировка"
    override val searchFilterTopBarClear: String
        get() = "Очистить"
    override val searchFilterTopBarClose: String
        get() = "Закрыть"
    override val searchFilterTopBarTitle: String
        get() = "Фильтр"
    override val searchFilterBottomBarClear: String
        get() = "Очистить"
    override val searchFilterBottomBarApply: String
        get() = "Применить"
    override val searchFilterLocationCityLabel: String
        get() = "Город"
    override val searchFilterLocationCityPlaceholder: String
        get() = "Выберите город"
    override val searchFilterLocationDistrictLabel: String
        get() = "Район"
    override val searchFilterLocationDistrictPlaceholder: String
        get() = "Выберите район"
    override val searchFilterPriceLabel: String
        get() = "Цена"
    override val searchFilterCostMinPlaceholder: String
        get() = "от"
    override val searchFilterCostMaxPlaceholder: String
        get() = "до"
    override val accommodationTypeLabel: String
        get() = "Тип жилья"
    override val accommodationTypeVilla: String
        get() = "Вилла"
    override val accommodationTypeAppartament: String
        get() = "Апартаменты"
    override val accommodationTypeGuesthouse: String
        get() = "Гест-хаус"
    override val accommodationTypeRoom: String
        get() = "Комната"
    override val searchFilterRoomsCountLabel: String
        get() = "Количество комнат"
    override val searchFilterAmenitiesLabel: String
        get() = "Дополнительно"
    override val favoritesTitle: String
        get() = "Избранное"
    override val favoritesLoadingLabel: String
        get() = "Загружаем ваши избранные объявления..."
    override val favoritesEmptyLabel: String
        get() = "Ваше избранное пока пусто. Добавляйте сюда понравившиеся объявления!"
    override val favoritesEmptyGoToSearchButton: String
        get() = "Перейти к поиску"
    override val searchSortScreenTitle: String
        get() = "Сортировать"
    override val searchSortScreenApply: String
        get() = "Применить"
    override val sortTypeNewest: String
        get() = "По новизне"
    override val sortTypeHighPrice: String
        get() = "Сначала дорогие"
    override val sortTypeLowPrice: String
        get() = "Сначала дешёвые"
    override val searchResultEmptyLabel: String
        get() = "По вашему запросу ничего не найдено, попробуйте изменить фильтры."
    override val searchResultAdjustFiltersButton: String
        get() = "Изменить фильтры"
    override val searchResultLoadingLabel: String
        get() = "Мы используем нейросеть для тщательного анализа и отбора самых ценных данных, чтобы предложить вам только то, что действительно важно."
    override val setupTitle: String
        get() = "Предварительные настройки"
    override val setupSubtitle: String
        get() = "Давайте настроим под вас приложение"
    override val setupLanguageSelect: String
        get() = "Какой язык вы хотите выбрать?"
    override val setupCountrySelect: String
        get() = "В какой стране искать?"
    override val setupCurrencySelect: String
        get() = "В какой валюте хотите видеть цены?"
    override val setupCongratsTitle: String
        get() = "Поздравляю, Вы успешно настроили приложение"
    override val setupCongratsSubtitle: String
        get() = "Желаем хорошего взаимодействия с приложением "
    override val setupContinueButton: String
        get() = "Продолжить"
    override val settingsTitle: String
        get() = "Настройки"
    override val settingsLanguageItem: String
        get() = "Язык"
    override val settingsCountryItem: String
        get() = "Страна"
    override val settingsCurrencyItem: String
        get() = "Валюта"
    override val settingsNewsItem: String
        get() = "Новости сервиса"
    override val settingsSupportItem: String
        get() = "Обратиться в поддержку"
    override val settingsPrivacyPolicyItem: String
        get() = "Политика конфиденциальности"
    override val settingsTermsOfUseItem: String
        get() = "Условия использования"
    override val languagePickerTitle: String
        get() = "Выбор языка"
    override val countryPickerTitle: String
        get() = "Выбор страны"
    override val currencyPickerTitle: String
        get() = "Выбор валюты"
}

